
import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { BsNewspaper } from 'react-icons/bs'
import { BsReceipt, BsReceiptCutoff } from 'react-icons/bs';
import { IoReceiptSharp } from 'react-icons/io5';
import { GiWashingMachine, GiFoldedPaper } from 'react-icons/gi';
import { MdLocalLaundryService, MdDeliveryDining, MdStore } from 'react-icons/md';
import { AiOutlineFileDone } from 'react-icons/ai';
import { FaLayerGroup } from 'react-icons/fa';
import axios, { AxiosError, AxiosResponse } from "axios";
import { sessionHandler } from '../util/local-storage';

import { posDetailJobStatus } from '../pages/Report/hook/useReportApi';
import UpdateSlipModal from '../pages/Retail/UpdateSlipModal';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));




export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}



// step 

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
            backgroundColor: "#303F9F"
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
            backgroundColor: "#303F9F"
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 1,

        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));



//end step  



// const steps = ['มีคำสั่งซื้อไหม่', 'ข้อมูลการชำระเงินได้รับการยืนยันแล้ว', 'คำสั่งซื้อที่ได้รับการจัดส่ง', 'ที่ต้องได้รับ', 'ให้คะแนน'];

export default function SearchComponent() {
    const [orderNumber, setOrderNumber] = useState("");
    const [openDialog, setOpenDialog] = React.useState(false);
    const [currentValue, setCurrentValue] = useState(0);
    const [steps, setSteps] = useState([]);
    const [jobDesc, setJobDesc] = useState([]);
    const [orderNo, setOrderNo] = useState("");
    const [serviceDate, setServiceDate] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [dataOrder, setDataOrder] = useState({});

    //const tokend = localStorage.getItem("token");

    const [isUpdateSlipModal, setUpdateSlipModal] = useState(false)
    const [orderDetail, setOrderDetail] = useState(null);
    const [showFullPreview, setShowFullPreview] = useState(false);



    const handleThumbnailClick = () => {
        setShowFullPreview(true);
    };

    const handleCloseFullPreview = () => {
        setShowFullPreview(false);
    };

    const seachTracking = (e) => {
        setShowFullPreview(false)
        e.preventDefault();



        var loc = {
            order_no: orderNumber,
            order_type: 'WDF'

        };



        //"order_no": "string",
        //"order_type": "string"
        (async function () {

            posDetailJobStatus(loc).then(function (response) {
                if (response.code === 401) {
                    //localStorage.clear();
                    sessionHandler.clear();
                } else {
                    var op
                    let objContent = response?.data?.content;
                    if (objContent != undefined && objContent.order_no) {
                        setDataOrder(objContent);

                        var jobs = objContent.jobs;
                        var opl = jobs.map(i => i?.desc ?? "");
                        // setSteps(opl);
                        setSteps(opl);
                        setJobDesc(jobs);
                        setOrderNo(objContent.order_no);
                        setServiceDate(objContent?.service_date);
                        setLocationCode(objContent?.location_code);
                        setCustomerName(objContent?.cust_name);
                        setPhoneNo(objContent?.cust_tel);
                        if (objContent.active != undefined) {
                            setCurrentValue(objContent.active);
                        }

                        setOpenDialog(true);

                    } else {

                    }
                }


            });

        })()



    }

    const handleClickOpen = () => {
        setOpenDialog(true);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };




    // step 
    // const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad', '', ''];

    function ColorlibStepIcon(props) {
        const { active, completed, className } = props;
        const statusCode = jobDesc[props.icon - 1]?.status_code;
        const icons = {
            'PUP':   <MdDeliveryDining />,
            'DROP':  <MdStore />,
            'RCV':   <IoReceiptSharp />,
            'WASH':  <GiWashingMachine />,
            'DRY':   <MdLocalLaundryService />,
            'FOLD':  <FaLayerGroup />,
            'DDROP': <MdStore />,
            'DLVD':  <MdDeliveryDining />,
            'POD':   <AiOutlineFileDone />,
        };

        return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                {icons[statusCode] ?? <AiOutlineFileDone />}
            </ColorlibStepIconRoot>
        );
    }
    const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#F5F5F5',
        zIndex: 1,
        color: '#C5CAE9',
        width: 70,
        height: 70,
        display: 'flex',
        // fontsize: 40,
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.active && {
            // backgroundImage:
            //     'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
            backgroundColor: '#fff',
            border: '4px solid #303F9F',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: '#303F9F',

        }),
        ...(ownerState.completed && {
            // backgroundImage:
            //     'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
            // backgroundColor: '#1976d2',
            backgroundColor: '#fff',
            border: '4px solid #303F9F',
            color: '#303F9F',
        }),
    }));


    // end step 

    // dailag

    const BootstrapDialogTitle = (props: DialogTitleProps) => {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    };

    //end dailog

    return (
        <div className="flex items-right">

            <div className="flex space-x-1">
                <input
                    type="text"
                    className="block w-full px-4 py-2 text-purple-700 bg-white border rounded-full focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    placeholder="Tracking..."
                    onChange={(event) => {
                        setOrderNumber(event.target.value)
                    }}
                    value={orderNumber}
                    onKeyDown={(event) => {

                        if (event.key === 'Enter') {
                            seachTracking(event);
                        }
                    }}

                />
                <button className="px-4 text-white  rounded-full " onClick={(event) => { seachTracking(event); }} >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                    </svg>
                </button>
            </div>

            <div>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={openDialog}
                    fullWidth={true}
                    maxWidth="md"
                >
                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                        ตรวจสอบสถานะ
                    </BootstrapDialogTitle>
                    <DialogContent
                    // dividers="paper"
                    >
                        <Typography gutterBottom>
                            <div className='pl-10 pr-10  justify-center items-center'>
                                <div className='mb-5 mt-5 flex justify-center items-center '>
                                    <div className='border rounded-md pt-5 pb-5 shadow-inner ' style={{ width: '85%' }}>
                                        <div className='flex justify-center items-center'>
                                            <div className='pl-2 pr-2 w-2/6'><label className='font-bold'>ชื่อลูกค้า :</label>   <label>{customerName}</label></div>
                                            <div className='pl-2 pr-2 w-3/6'><label className='font-bold'>เบอร์โทร :</label>   <label>{phoneNo}</label></div>
                                        </div>
                                        <div className='flex justify-center items-center '>
                                            <div className='pl-2 pr-2 w-2/6'><label className='font-bold'>เลขที่ :</label>   <label>{orderNo}</label></div>
                                            <div className='pl-2 pr-2 w-3/6' ><label className='font-bold' >วันที่ใช้บริการ :</label>   <label>{serviceDate}</label></div>
                                        </div>

                                        <div className='flex justify-center items-center '>

                                            <div className='pl-2 pr-2 w-2/6'> <label className='font-bold'>สาขา :</label>   <label>{dataOrder?.location_desc}</label></div>
                                            <div className='pl-2 pr-2 w-3/6'> <label className='font-bold'>วันที่ชำระเงินสำเร็จ :</label>   <label>{dataOrder?.created_date}</label></div>

                                        </div>

                                        <div className='flex justify-center items-center '>

                                            <div className='pl-2 pr-2 w-2/6'> <label className='font-bold'> </label>   <label> </label></div>
                                            <div className='pl-2 pr-2 w-3/6'> <label className='font-bold'>สถานะ :</label>   <label>{dataOrder?.order_status_desc}</label></div>

                                        </div>
                                    </div>

                                    {/* show component when have slip uploaded */}
                                    {dataOrder?.slip_img === null ?
                                        null :
                                        <div className="w-1/4 justify-end items-center">
                                            {/* slip manage */}
                                            <div className="items-center text-center">
                                                <div className="pl-8 pr-2 w-full justify-center text-center">
                                                    {" "}

                                                    {dataOrder?.slip_img && (
                                                        <div style={{ textAlign: "-webkit-center" }} className='text-center'>
                                                            <img
                                                                onClick={handleThumbnailClick}
                                                                style={{
                                                                    objectFit: "scale-down",
                                                                    maxWidth: "100%",
                                                                    height: "75px",
                                                                    maxHeight: "80px",
                                                                    cursor: "pointer",
                                                                    textAlign: "-webkit-center"
                                                                }}
                                                                src={dataOrder?.slip_img}
                                                                alt="OldSlip"
                                                                className="drop-shadow-xl rounded-lg max-w-xs cursor-pointer "
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {showFullPreview &&
                                                dataOrder?.slip_img !== null && (
                                                    <div
                                                        onClick={handleCloseFullPreview}
                                                        style={{
                                                            position: "fixed",
                                                            top: "0",
                                                            left: "0",
                                                            width: "100%",
                                                            height: "100%",
                                                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                                                            zIndex: "999",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <img
                                                            src={dataOrder?.slip_img}
                                                            alt="Full preview"
                                                            style={{
                                                                maxWidth: "80%",
                                                                maxHeight: "80%",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    }

                                </div>

                                <div className='mb-10 mt-10' >
                                    <div className=''>
                                        <Stepper activeStep={currentValue ?? 0} alternativeLabel connector={<ColorlibConnector />}>
                                            {steps.map((label, idex) => (
                                                <Step key={label}>
                                                    <StepLabel style={{ fontSize: "40px" }} StepIconComponent={ColorlibStepIcon} >{label}
                                                        <div className='clear-both'></div>
                                                        {jobDesc[idex]?.status_date}
                                                        <div className='clear-both'></div>
                                                        {jobDesc[idex]?.pic}
                                                    </StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </div>

                                </div>



                            </div>
                        </Typography>

                        <UpdateSlipModal
                            isDisplay={isUpdateSlipModal}
                            //   passSearchPossummary={passSearchPossummary}
                            jobcd={jobDesc ? jobDesc : ""}
                            dataOrder={dataOrder}
                            orderNo={orderNo}
                            orderDetail={orderDetail}
                            onClose={() => {
                                setUpdateSlipModal(false);
                            }}
                            onSuccess={() => {
                                // onSearchTracking();
                                setUpdateSlipModal(false);
                                // handleClose();
                            }}
                        />

                    </DialogContent>

                </BootstrapDialog>
            </div>
        </div >
    );
}